// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"247":"Recommendations-RecommendationsContainer","873":"SavedSearch-Container-SavedSearchesContainer"}[chunkId] + "-" + {"247":"2610d4c6559629f3973e","873":"b1be4619c9344180d1a6"}[chunkId] + ".css";
};